import { Divider, Header } from 'semantic-ui-react'

const SectionHeader = ({ title }) => {
    return (
      <Divider horizontal>
          <Header as="h4">
              {title}
          </Header>
      </Divider>
    )
}

export { SectionHeader }
